<template>
  <div>
    <v-dialog
      :value="props.value"
      @input="emit('input', $event)"
      max-width="700"
      persistent
    >
      <v-card class="confirm-dialog-card pa-1" rounded="lg">
        <v-btn @click="cancel" small icon class="float-right mr-3 mt-3">
          <v-icon>close</v-icon>
        </v-btn>

        <v-row>
          <v-col>
            <p class="primary--text title ml-4 mt-3 mb-0">
              {{ $t("qrAppTitle") }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              class="primary--text mx-7"
              style="text-align: start; font-size: 0.8rem"
              v-html="$t('qrAppText')"
            ></div>
          </v-col>
        </v-row>
        <v-row class="mb-5">
          <v-col cols="6" class="d-flex justify-space-around">
            <v-img src="@/assets/AppStore.png" max-width="250"> </v-img>
          </v-col>
          <v-col cols="6" class="d-flex justify-space-around">
            <v-img src="@/assets/GooglePlay.png" max-width="250"> </v-img>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{ value: boolean }>();

const emit = defineEmits<{
  (event: "input", value: boolean): void;
}>();

const cancel = async () => {
  emit("input", false);
};
</script>

<style scoped>
.qr-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.confirm-dialog-card {
  overflow: hidden !important;
}

.v-col {
  display: flex;
  justify-content: space-around;
}
</style>
